import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {BadgesOverviewComponent} from './badges-overview.component';

const routes: Routes = [
  {path: 'badges', component: BadgesOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class BadgesOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-overview/badges-overview-routing.module.ts